export const PublicSiteResultsPlaceholderPage = ({ numberOfCards }) => {
	return (
		<div className="public-search-page">
			<section className="public-search-page-header-container">
				<div className="public-search-page-header ddx-container">
					<div className="public-search-page-header-content">
						<div className="public-search-page-header-results-text">
							<div className="placeholder-pulse" />
						</div>
						<div className="public-search-sort-by-placeholder">
							<div className="placeholder-pulse" />
						</div>
					</div>
				</div>
			</section>
			<div className="public-search-results ddx-container">
				{...Array(numberOfCards).fill(
					<div className="public-search-result-card">
						<div className="public-search-result-card-content">
							<div className="public-search-result-card-left">
								<div className="search-page-results-placeholder-card-eyebrow placeholder-pulse"></div>
								<div className="search-page-results-placeholder-card-title placeholder-pulse"></div>
								<div className="search-page-results-placeholder-card-summary placeholder-pulse"></div>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
